import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import { CustomerHeader } from './containers/CustomerHeader';
import { CustomerList } from './containers/CustomerList';
import { RegistrationModal } from './containers/RegistrationModal';
import { EditModal } from './containers/EditModal';
import { ContractRegistrationModal } from './containers/ContractRegistrationModal';
import { ContractEditModal } from './containers/ContractEditModal';

export const CustomerPageView: FC = () => (
  <Box m="40px 40px">
    {/* ヘッダ */}
    <CustomerHeader />
    {/* 顧客一覧 */}
    <CustomerList />
    {/* 顧客情報登録モーダル */}
    <RegistrationModal />
    {/* 顧客情報編集モーダル */}
    <EditModal />
    {/* 契約メニュー登録モーダル */}
    <ContractRegistrationModal />
    {/* 契約メニュー編集モーダル */}
    <ContractEditModal />
  </Box>
);
